var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"costUploader",attrs:{"id":"cost-uploader","type":"file"},on:{"change":_vm.onChange}}),_c('span',{on:{"click":_vm.onClick}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }